import { apiDaInscricao } from './axios';

export const buscarDadosParaHistorico = async (idDaInscricao:number, cpf: string) => {
  return await apiDaInscricao().get(`/HistoricoDaInscricao/${idDaInscricao}/historico/${cpf}`);
};